import { render, staticRenderFns } from "./SelectTab.vue?vue&type=template&id=858ff8ce&"
import script from "./SelectTab.vue?vue&type=script&lang=js&"
export * from "./SelectTab.vue?vue&type=script&lang=js&"
import style0 from "./SelectTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SelectTab.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VTab,
  VTabs,
})
